import React, { useEffect, useContext, useRef, useState } from 'react';
import { Container, Col, Row } from 'reactstrap';
import styles from './NJRLanding.module.css';
import { ReactComponent as ExclaimationCircle } from '../../assets/images/exclamation-circle.svg';
import Accordion from '../shared/AccordionCard/Accordion';
import { BrandingContext } from '../contexts/ContractContext';
import { useHistory } from 'react-router-dom';

const discFaqs = [
    {
        question: 'How does this impact my existing monthly service plan?',
        answer: 'Payments will not be charged to your credit card after March 1, 2023. For customers on an existing monthly payment plan, product coverage will continue for 30 days after your last payment is processed. If you have questions, please call us at 877-531-4782.'
    },
    {
        question: 'How does this impact my existing annual service plan?',
        answer: 'Payments will not be charged to your credit card after March 1, 2023. For customers on an existing annual payment plan, product coverage will continue through the end of your contract term. If you have any questions, please call us at 877-531-4782.'
    }
];

const NJRDecommission = () => {
    return (
        <Container>
            <section
                id='approvedClaim'
                className={styles.confirmSection}
            >
                <Row>
                    <Col xs={12}>
                        <ExclaimationCircle className={styles.errorIcon} />
                        <h2 className={`h1 ${styles.brandColor}`}>Attention: Program Discontinued </h2>
                        <p>
                            NJR Retail and AIG have discontinued the Kitchen and Laundry Appliance Plans. These service
                            <br />
                            contracts are no longer being sold and existing contracts will not be renewed after March 1,
                            2023.
                        </p>
                        <p className='mt-2'>
                            We are sorry for the inconvenience. If you'd like to speak with one of our representatives,
                            call 877-531-4782.
                        </p>
                    </Col>
                    <Col
                        xs={12}
                        className='mt-5'
                    >
                        <h1 className='h3'>Existing Customer</h1>
                        <div className={styles.faqs}>
                            {discFaqs.map(({ question, answer }) => (
                                <Accordion
                                    question={question}
                                    answer={answer}
                                />
                            ))}
                        </div>
                    </Col>
                </Row>
            </section>
        </Container>
    );
};

export default NJRDecommission;
